import Dam from '../dam/dam'
import ValueBox from '../value_box/value_box'
import store from '../../../../store/store'

import('./line.css')

export default function Line(opts={}){
    BaseConstructor.call(this)
    let container = opts.container
    let elements = {}
    let context = this
    let options = opts.options || {}
    let _path, _info_container_el, _title_el,_flow_el
    let _orientation

    this.generate = () =>{
        let {position, title, flow, objects} = options

        _path = document.createElementNS('http://www.w3.org/2000/svg', 'line');

        // <line x1="60" y1="50" x2="100" y2="50" stroke="black" />
        _path.classList.add('horizontal')
        // _path.setAttribute('d', `M${position.left} ${position.top} H${position.x}`);

        

        _path.setAttribute('fill', 'none');
        _path.setAttribute('stroke-width', '15px')
        _path.setAttribute('stroke', '#66c9ff');
        _path.setAttribute('stroke-linecap', 'round')

        _orientation = position.start[0] != position.finish[0] ? 'horizontal' : 'vertical'

        $(container).append(_path)     
        
        
        if(title){
            this.setTitle()
        }
        
        if(objects){
            if(objects.box_values){
                this.setBoxes(objects.box_values)
            }
            if(objects.dams){
                this.setDams(objects.dams)
            }
        }
        
        setPosition()

        if(flow && flow.show){
            this.setFlow(flow)
        }

        $(document.body).append(_info_container_el)

        window.addEventListener('resize', setPosition)
        
        $('.canvas-container')[0].addEventListener('scroll', function(event) { setPosition() })
        
    }
    
    const setPosition = () =>{
        let {position,title} = options
        _path.setAttribute('x1', convertPosition(position.start[0], 'w'))
        _path.setAttribute('y1', convertPosition(position.start[1], 'h'))
        _path.setAttribute('x2', convertPosition(position.finish[0],'w'))
        _path.setAttribute('y2', convertPosition(position.finish[1], 'h'))
        store.diagramStore.pathUpdatePosition(_path)

        if(title){
            this.updateInfoPosition()
        }
        
    }

    this.setDams = dams =>{
        
        dams.forEach(dam=>{
            let dam_opts = {
                id: dam.id,
                options:dam,
                path: _path,
                container:container
            }

            if(dam.floodgates && dam.floodgates.show && dam.floodgates.total > 0){
                dam_opts = {...dam_opts, ...{floodgates: dam.floodgates}}
            }

            let damComponent = new Dam(dam_opts)
            damComponent.generate()
        })
    }

    this.setBoxes = boxes =>{
        boxes.forEach(options=>{
            let valueBox = new ValueBox({options:options, path: _path, container:container})
            valueBox.generate()
        })
        
    }

    this.setFlow = (flow_options) =>{
        const iconByDirection = direction =>{
            return 'fas fa-angle-double-'+direction
        }
        let direction = flow_options.direction
        direction = direction == 'up' ? 'right' : direction == 'down' ? 'left' : direction
        if(direction){
            if(!_info_container_el){
                _info_container_el = this.createElement('div', 'line-info-container')    
            }
    
            _flow_el = this.createElement('div', '', `<span class="flow-icon-container  to${direction}"><i class="${iconByDirection(direction)}"></i></span>`)
            _flow_el.classList.add('line-flow-container')
            setFlowSize()
            $(_info_container_el).append(_flow_el)
        } else {
            console.log('There is no flow without direction...', flow_options)
        }
        

        // this.updateFlowPosition()
    }

    this.setTitle = _ =>{
        let {title} = options
        if(!_info_container_el){
            _info_container_el = this.createElement('div', 'line-info-container')    
        }
        _title_el = this.createElement('div', '', title.text)
        _title_el.classList.add('line-title-container')
        $(_info_container_el).append(_title_el)

        this.updateInfoPosition()

    }

    this.updateInfoPosition = _ =>{
        let offset = $(_path).offset()
        let box = _path.getBBox()

        if(_orientation == 'horizontal'){
            $(_info_container_el).css({
                position: 'absolute',
                top: offset.top,
                left: offset.left,
                width: box.width
            })
        } else {
            $(_info_container_el).css({
                position: 'absolute',
                'transform-origin': '0% 50%',
                transform: 'rotate(-90deg)',
                top: offset.top + box.height,
                left: offset.left,
                width: box.height
            })
        }

        
    }
    this.update = () =>{
        
    }

    const convertPosition = (pos, type) =>{
        let container_w = $(container).width()
        let container_h = $(container).height()
        if(type == 'w'){
            return pos * container_w / 100
        } else {
            return pos * container_h / 100
        }
    }

    const setFlowSize = _ =>{
        let path_bbox = _path.getBBox()
        $(_flow_el).css({
            width: (path_bbox.width || path_bbox.height) > 250 ? 250 : (path_bbox.width || path_bbox.height)
        })
    }
}

Line.prototype = Object.create(BaseConstructor.prototype)